import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "src/environments/environment";
import { EstatusJSON } from "../../models/EstatusJSON";
import { IApiBase } from "./Interface/IApiBase.interface";
import { CatalogPaginationRequest } from "../../models/CatalogPagination/CatalogPaginationRequest";
import { FilterRequest } from "../../models/Filter/FilterRequest";

@Injectable({
  providedIn: "root",
})
export class GeoClustersFrecuencyPlacesAPIService implements IApiBase{
  configUrl: string;

  constructor(private http: HttpClient) {
    this.configUrl = environment.host;
  }
  insert() {
    throw new Error("Method not implemented.");
  }
  update(datos: any) {
    throw new Error("Method not implemented.");
  }
  delete(id: any) {
    throw new Error("Method not implemented.");
  }
  getFilterValues(request: FilterRequest[]) {
    throw new Error("Method not implemented.");
  }
  getPage(pageRequest: CatalogPaginationRequest) {
    throw new Error("Method not implemented.");
  }
  getCount(pageRequest: CatalogPaginationRequest) {
    throw new Error("Method not implemented.");
  }


  GetByIdentifier(identifier: string) {
    return this.http.get<EstatusJSON>( this.configUrl + "/api/GeoClustersFrecuencyPlaces/GetByIdentifier?identifier=" + identifier,{});
  }

  GetByIdentifierGeoJson(identifier: string) {
    return this.http.get<EstatusJSON>( this.configUrl + "/api/GeoClustersFrecuencyPlaces/GetByIdentifierGeoJson?identifier=" + identifier,{});
  }
}
